var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconFile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-file",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39 22",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n.icon-file .st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.76,10.6C37.5,10.2,31.2,0.71,19.5,0.71c-11.7,0-18,9.49-18.26,9.89c-0.16,0.24-0.16,0.56,0,0.8 c0.26,0.4,6.56,9.89,18.26,9.89c11.7,0,18-9.49,18.26-9.89C37.92,11.16,37.92,10.84,37.76,10.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,5.01c-3.3,0-5.99,2.69-5.99,5.99c0,3.3,2.69,5.99,5.99,5.99c3.3,0,5.99-2.69,5.99-5.99 C25.49,7.7,22.8,5.01,19.5,5.01z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,7.41c-1.98,0-3.59,1.61-3.59,3.59"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_file.9be61579.svg";
export { ForwardRef as ReactComponent };